import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "index"
};
import CustomBar from "@/components/customBar";
import { onMounted, ref } from "vue";
import { my_redeems } from "@/api/index";
export default {
  __name: 'index',
  setup(__props) {
    const data = ref({});
    onMounted(() => {
      my_redeems().then(res => {
        data.value = res;
      });
    });
    return (_ctx, _cache) => {
      const _component_van_cell = _resolveComponent("van-cell");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(CustomBar), {
        title: "我的积分"
      }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_cell, {
        title: "积分数量",
        value: data.value.redeemQty
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "积分转让",
        "is-link": "",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('integralTurn'))
      }), _createVNode(_component_van_cell, {
        title: "随身仓库存",
        value: data.value.stock
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "随身仓出库",
        "is-link": "",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push('carryOnStorage'))
      })])], 64);
    };
  }
};